module.exports = __webpack_public_path__ + "img/map_Z5.7.A.01.58fc9010.svg";